import { render, staticRenderFns } from "./POLifecycleGuide.vue?vue&type=template&id=2e7c20be&scoped=true"
import script from "./POLifecycleGuide.vue?vue&type=script&lang=ts"
export * from "./POLifecycleGuide.vue?vue&type=script&lang=ts"
import style0 from "./POLifecycleGuide.vue?vue&type=style&index=0&id=2e7c20be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c20be",
  null
  
)

export default component.exports